
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BeforeAfter from "../pages/before-after/page";
import CaseDetail from "../pages/case-detail/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/before-after",
    element: <BeforeAfter />,
  },
  {
    path: "/case-detail/:id",
    element: <CaseDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
